export class EmailPreferences {
  public newsletters: boolean;
  public salesAndPromotions: boolean;
  public membersOnlyEmails: boolean;
  public productUpdates: boolean;
}
